import React from 'react';
import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {useDispatch} from 'react-redux';
import * as snackbarsActions from '../../../actions/snackbars';
import InvitationView from './InvitationView';
import enrollmentService from '../../../services/enrollment';
import relationshipService from '../../../services/relationship/RelationshipService';

function InvitationContainer(props) {
  const dispatch = useDispatch();
  const [isPanelOpen, setIsPanelOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  function handleResendInvitation(service, invitationId, recepient, reason = '') {
    setLoading(true);
    service.resendInvitation(invitationId, reason)
      .then(() => {
        setIsPanelOpen(false);
        props.onRefreshRequested();
        dispatch(snackbarsActions.addSuccess(<Translate
          value="subcontractor.invite.resendSuccess"
          name={recepient}
        />));
      })
      .catch(() => dispatch(snackbarsActions.addError(<Translate value="error.generic"/>)))
      .finally(() => setLoading(false));
  }

  function handleClickResendInvitation() {
    const invitationId = props.invitation.relationshipId || props.invitation.invitationId;
    if (invitationId !== undefined) {
      if (props.invitation.relationshipId) {
        const fullName = (props.isSubcontractorView && props.invitation.subcontractor?.fullName) || props.invitation.client?.fullName;
        handleResendInvitation(relationshipService, invitationId, fullName);
      } else {
        setIsPanelOpen(true);
      }
    }
  }

  return (
    <InvitationView
      invitation={props.invitation}
      onResendInvitation={handleClickResendInvitation}
      onCancelSuccess={props.onRefreshRequested}
      isSubcontractorView={props.isSubcontractorView}
      isPanelOpen={isPanelOpen}
      onClosePanel={() => setIsPanelOpen(false)}
      onSubmitReason={ reason => handleResendInvitation(enrollmentService.network, props.invitation.invitationId, props.invitation.organisationName, reason)}
      loading={loading}
    />
  );
}

InvitationContainer.propTypes = {
  invitation: PropTypes.object.isRequired,
  onRefreshRequested: PropTypes.func.isRequired,
  isSubcontractorView: PropTypes.bool
};

export default InvitationContainer;
